// ProgressTracker — penjejak status bukti bayar (3 langkah) untuk portal orang tua.
// Tahap diperoleh dari status + dibuka_bendahara_at:
//   pending + dibuka_bendahara_at null -> langkah 1 aktif ("Bukti Diterima")
//   pending + dibuka_bendahara_at ada   -> langkah 2 aktif ("Sedang Disemak")
//   lulus  -> langkah 3 selesai ("Selesai")
//   tolak  -> langkah 3 gagal ("Ditolak")
// Visual: spek Bang Eko (royal blue #1E3A8A + gold #F59E0B, mobile-first).
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Check, X, Loader2 } from 'lucide-react';

const BLUE = '#1E3A8A';
const GOLD = '#F59E0B';

export function proofStage(proof) {
  if (!proof) return 'uploaded';
  if (proof.status === 'lulus') return 'approved';
  if (proof.status === 'tolak') return 'rejected';
  if (proof.dibuka_bendahara_at) return 'reviewing';
  return 'uploaded';
}

export default function ProgressTracker({ proof }) {
  const { t } = useTranslation();
  const stage = proofStage(proof);
  const rejected = stage === 'rejected';

  const steps = [
    { key: 'tracker.step1' },
    { key: 'tracker.step2' },
    { key: rejected ? 'tracker.step3Rejected' : 'tracker.step3' },
  ];
  // indeks langkah aktif: uploaded=0, reviewing=1, approved/rejected=2
  const activeIdx = stage === 'uploaded' ? 0 : stage === 'reviewing' ? 1 : 2;

  return (
    <div className="w-full py-3" data-testid="progress-tracker">
      <ol className="flex items-start">
        {steps.map((s, i) => {
          const done = i < activeIdx || (i === activeIdx && stage === 'approved');
          const active = i === activeIdx;
          const failed = active && rejected;
          let circle, icon;
          if (failed) {
            circle = { border: `2px solid #DC2626`, background: '#fff' };
            icon = <X size={14} strokeWidth={3} color="#DC2626" />;
          } else if (done) {
            circle = { border: `2px solid ${GOLD}`, background: GOLD };
            icon = <Check size={14} strokeWidth={3} color="#fff" />;
          } else if (active) {
            circle = { border: `2px solid ${BLUE}`, background: '#fff' };
            icon = stage === 'reviewing'
              ? <Loader2 size={14} color={BLUE} className="animate-spin" />
              : <span className="text-[11px] font-bold" style={{ color: BLUE }}>{i + 1}</span>;
          } else {
            circle = { border: '2px solid #D1D5DB', background: '#fff' };
            icon = <span className="text-[11px] font-medium text-muted-foreground">{i + 1}</span>;
          }
          return (
            <li key={s.key} className="flex-1 flex flex-col items-center relative">
              {i > 0 && (
                <div
                  aria-hidden
                  className="absolute top-[14px] right-1/2 w-full h-[2px]"
                  style={{ background: i <= activeIdx || done ? BLUE : '#D1D5DB' }}
                />
              )}
              <span
                className="relative z-10 w-7 h-7 rounded-full flex items-center justify-center bg-card"
                style={circle}
              >
                {icon}
              </span>
              <span
                className={`mt-1.5 text-[10px] leading-tight text-center max-w-[76px] ${active ? 'font-bold' : 'font-medium text-muted-foreground'}`}
                style={active && !failed ? { color: BLUE } : failed ? { color: '#DC2626' } : undefined}
              >
                {t(s.key)}
              </span>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
